module.exports = __webpack_public_path__ + "img/LogoStattus4Verde.32d933a7.png";